module.exports = __webpack_public_path__ + "img/216.455b6d10.jpg";